<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _ from 'lodash'
import ListingDetail from '@/modules/realestate/views/ListingDetail.vue'
import { FlashOfferListActionTypes, useFlashOfferListStore } from '@/modules/flashoffer/stores/flashoffer.list.store.ts'
import { useConfirm, useToast } from 'primevue'


const router = useRouter()
const flashOfferListStore = useFlashOfferListStore()

const confirm = useConfirm()
const toast = useToast()
const pageTabs = computed(() => {
  return flashOfferListStore.tabs
})
const displayTabContent = computed(() => {
  return flashOfferListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return flashOfferListStore.tableConfig
})
const filter = computed(() => {
  return flashOfferListStore.filter
})
const loading = computed(() => {
  return flashOfferListStore.action_type == FlashOfferListActionTypes.FETCHING
})
const page = computed(() => {
  return flashOfferListStore.page
})
const pageSize = computed(() => {
  return flashOfferListStore.pageSize
})
const dataSource = computed(() => {
  return flashOfferListStore.data
})
const selectedIds = computed(() => {
  return flashOfferListStore.selectedIds
})

const handleChangeTab = (tab: any) => {

  flashOfferListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  flashOfferListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  flashOfferListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  flashOfferListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  flashOfferListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  flashOfferListStore.setFilter(filter)
}

const handleGotoDetail = (e: MouseEvent, item: any) => {

  router.push({ name: 'flash-offer-detail', params: { id: item.id } })
  // flashOfferListStore.newTab({id: item.code, label: `#${item.code} - ${item.subject?.title}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {
  flashOfferListStore.setSelectedRow(ids)
}

const handleSort = (field: string, direction: string) => {

  flashOfferListStore.toggleSort(field, direction)
}

const requestFetchFOList = _.debounce(async () => {
  try{
    const res = await flashOfferListStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> flashOfferListStore.uuid, (newVal, oldVal) => {
  requestFetchFOList()
})

onMounted(() => {
  // if(flashOfferListStore.action_type === FlashOfferListActionTypes.PENDING) requestFetchFOList()
  requestFetchFOList()
})

const handleStopFlashOffer = async () => {
  if(selectedIds.value.length === 0) {
    toast.add({ severity: 'error', summary: 'Error', detail: 'Vui lòng chọn Flash Offer để dừng', life: 3000 });
    return;
  }
  confirm.require({
    message: 'Bạn có muốn xóa tài khoản đã chọn?',
    header: 'Xác nhận',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: async () => {
      const res: any = await flashOfferListStore.stopFlashOffer(selectedIds.value);
      if(res.data.code === 200) {
        toast.add({ severity: 'success', summary: 'Success', detail: 'Dừng Flash Offer thành công', life: 3000 });
      } else {
        toast.add({ severity: 'error', summary: 'Error', detail: 'Dừng Flash Offer thất bại', life: 3000 });
      }
    },
    reject: () => {
    }
  })
}
</script>

<template>
  <dashboard-layout currentRoute="flash-offer/list" page-title="Quản lý Flash Offer">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
        @reset:filter="flashOfferListStore.resetFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        :buttons="[
          {
            label: 'Tạo Flash Offer',
            icon: 'gridicons:create',
            class: 'btn bg-primary bg-hover-primary text-white',
            action: () => {
              router.push({ name: 'flash-offer-create' })
            },
            perm: 'flash_offer.create_flash_offer',
            selectRequired: false
          },
          {
            label: 'Ngưng hoạt động',
            icon: 'tabler:trash',
            class: 'btn btn-danger bg-hover-danger ',
            action: handleStopFlashOffer,
            perm: 'flash_offer.stop_flash_offer',
            selectRequired: true
          },
        ]"
        :row-action-buttons="[
          { action: handleGotoDetail, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone', perm: 'flash_offer.view_flash_offer' }
        ]"
        primaryField="id"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="flashOfferListStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-row-click="handleRowClick"
        @on-sort="handleSort"

      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <ListingDetail :id="tab.id" :key="tab.id"/>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
